module.exports = __webpack_public_path__ + "img/about1 (3).376d5b8e.png";